import { render, staticRenderFns } from "./service-select.vue?vue&type=template&id=6969dd44&scoped=true"
import script from "./service-select.vue?vue&type=script&lang=js"
export * from "./service-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6969dd44",
  null
  
)

export default component.exports